var map = {
	"./icons/broken-image.svg": "abee",
	"./icons/female-ico.svg": "31bf",
	"./icons/figure-ico.svg": "d460",
	"./icons/foot-ico.svg": "c5c0",
	"./icons/fullscreen-default.svg": "b4e4",
	"./icons/hand-ico.svg": "7487",
	"./icons/head-ico.svg": "8cfb",
	"./icons/male-ico.svg": "a030",
	"./icons/miscellaneous-ico.svg": "1d6a",
	"./icons/no-data.svg": "fb14",
	"./icons/type-ico.svg": "ee91",
	"./icons/upload.svg": "a13b",
	"./visualisations/files/female-adult-figure.svg": "387c",
	"./visualisations/files/female-adult-foot.svg": "a4b45",
	"./visualisations/files/female-adult-hand.svg": "67ab",
	"./visualisations/files/female-adult-head.svg": "96e4",
	"./visualisations/files/female-child-figure.svg": "9f12",
	"./visualisations/files/female-child-foot.svg": "1592",
	"./visualisations/files/female-child-hand.svg": "0f19",
	"./visualisations/files/female-child-head.svg": "8f04",
	"./visualisations/files/female-elderly-figure.svg": "4f2f",
	"./visualisations/files/female-elderly-foot.svg": "4958",
	"./visualisations/files/female-elderly-hand.svg": "afe8",
	"./visualisations/files/female-elderly-head.svg": "cb2e",
	"./visualisations/files/female-infant-figure.svg": "d08a",
	"./visualisations/files/female-infant-foot.svg": "61ac",
	"./visualisations/files/female-infant-hand.svg": "8fa8",
	"./visualisations/files/female-infant-head.svg": "a8ff",
	"./visualisations/files/female-newborn-figure.svg": "e959",
	"./visualisations/files/female-newborn-foot.svg": "4c68",
	"./visualisations/files/female-newborn-hand.svg": "1a44",
	"./visualisations/files/female-newborn-head.svg": "0100",
	"./visualisations/files/female-teenager-figure.svg": "c45d",
	"./visualisations/files/female-teenager-foot.svg": "59b2",
	"./visualisations/files/female-teenager-hand.svg": "d261",
	"./visualisations/files/female-teenager-head.svg": "e13e",
	"./visualisations/files/female-youngadult-figure.svg": "2f74",
	"./visualisations/files/female-youngadult-foot.svg": "df64",
	"./visualisations/files/female-youngadult-hand.svg": "80ee",
	"./visualisations/files/female-youngadult-head.svg": "aa5b",
	"./visualisations/files/female-youngchild-figure.svg": "7562",
	"./visualisations/files/female-youngchild-foot.svg": "beec",
	"./visualisations/files/female-youngchild-hand.svg": "a8a7",
	"./visualisations/files/female-youngchild-head.svg": "a149",
	"./visualisations/files/male-adult-figure.svg": "20fe",
	"./visualisations/files/male-adult-foot.svg": "4e72",
	"./visualisations/files/male-adult-hand.svg": "d3f4",
	"./visualisations/files/male-adult-head.svg": "836f",
	"./visualisations/files/male-child-figure.svg": "4022",
	"./visualisations/files/male-child-foot.svg": "1f75",
	"./visualisations/files/male-child-hand.svg": "788f",
	"./visualisations/files/male-child-head.svg": "b31d",
	"./visualisations/files/male-elderly-figure.svg": "0089",
	"./visualisations/files/male-elderly-foot.svg": "75bb",
	"./visualisations/files/male-elderly-hand.svg": "c421",
	"./visualisations/files/male-elderly-head.svg": "4508",
	"./visualisations/files/male-infant-figure.svg": "1c0c",
	"./visualisations/files/male-infant-foot.svg": "9b52",
	"./visualisations/files/male-infant-hand.svg": "94f5",
	"./visualisations/files/male-infant-head.svg": "470f",
	"./visualisations/files/male-newborn-figure.svg": "a54e",
	"./visualisations/files/male-newborn-foot.svg": "5c96",
	"./visualisations/files/male-newborn-hand.svg": "4089",
	"./visualisations/files/male-newborn-head.svg": "814f",
	"./visualisations/files/male-teenager-figure.svg": "e146",
	"./visualisations/files/male-teenager-foot.svg": "5955",
	"./visualisations/files/male-teenager-hand.svg": "0dab",
	"./visualisations/files/male-teenager-head.svg": "fd11",
	"./visualisations/files/male-youngadult-figure.svg": "9f63",
	"./visualisations/files/male-youngadult-foot.svg": "a72e",
	"./visualisations/files/male-youngadult-hand.svg": "cb29",
	"./visualisations/files/male-youngadult-head.svg": "22c7",
	"./visualisations/files/male-youngchild-figure.svg": "9230",
	"./visualisations/files/male-youngchild-foot.svg": "08d0",
	"./visualisations/files/male-youngchild-hand.svg": "3e6b",
	"./visualisations/files/male-youngchild-head.svg": "10d6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";